var map = {
	"./ant_1.mp3": 13136,
	"./ant_2.mp3": 26855,
	"./at_1.mp3": 87402,
	"./at_2.mp3": 48509,
	"./axe.mp3": 61299,
	"./back_1.mp3": 95440,
	"./back_2.mp3": 50375,
	"./bake.mp3": 98954,
	"./bat.mp3": 45938,
	"./beast.mp3": 25378,
	"./bee_1.mp3": 81171,
	"./bee_2.mp3": 20796,
	"./bin.mp3": 22688,
	"./binbin.mp3": 64455,
	"./block.mp3": 11756,
	"./boat.mp3": 7071,
	"./boot_1.mp3": 81205,
	"./boot_2.mp3": 55074,
	"./born_1.mp3": 92968,
	"./born_2.mp3": 11871,
	"./boss.mp3": 85806,
	"./box.mp3": 65436,
	"./car_1.mp3": 57017,
	"./car_2.mp3": 39654,
	"./cash_1.mp3": 12700,
	"./cash_2.mp3": 94035,
	"./cat.mp3": 10987,
	"./cheer.mp3": 50172,
	"./chip_1.mp3": 85503,
	"./chip_2.mp3": 50248,
	"./coast.mp3": 91869,
	"./coat.mp3": 34576,
	"./conn.mp3": 10627,
	"./corn.mp3": 70807,
	"./cost.mp3": 25614,
	"./cot.mp3": 83061,
	"./day.mp3": 71129,
	"./day_1.mp3": 6941,
	"./day_2.mp3": 68938,
	"./deck.mp3": 96386,
	"./dip.mp3": 56964,
	"./ditch.mp3": 98605,
	"./dog.mp3": 84333,
	"./door.mp3": 83437,
	"./due.mp3": 18777,
	"./egg.mp3": 85544,
	"./egg_1.mp3": 82892,
	"./egg_2.mp3": 71331,
	"./fade.mp3": 91179,
	"./fall.mp3": 83190,
	"./fan_1.mp3": 90936,
	"./fan_2.mp3": 90831,
	"./fat.mp3": 55302,
	"./fat_1.mp3": 50942,
	"./fat_2.mp3": 42929,
	"./fate.mp3": 95259,
	"./feast.mp3": 58670,
	"./feet.mp3": 58457,
	"./feet_1.mp3": 94205,
	"./feet_2.mp3": 2474,
	"./fern.mp3": 84578,
	"./file_float.mp3": 51972,
	"./fin.mp3": 26484,
	"./find.mp3": 34696,
	"./fine.mp3": 24653,
	"./fleet.mp3": 53995,
	"./flip.mp3": 24448,
	"./float.mp3": 33641,
	"./fold.mp3": 86832,
	"./fort.mp3": 58410,
	"./fox_1.mp3": 47924,
	"./fox_2.mp3": 52619,
	"./fuel.mp3": 8113,
	"./fun.mp3": 63008,
	"./gate.mp3": 91076,
	"./get.mp3": 9875,
	"./goat.mp3": 26676,
	"./gold.mp3": 44543,
	"./hard.mp3": 37850,
	"./hat.mp3": 16388,
	"./hate.mp3": 7965,
	"./hay.mp3": 72530,
	"./head.mp3": 82487,
	"./hen.mp3": 49194,
	"./her_1.mp3": 77942,
	"./her_2.mp3": 24329,
	"./herd.mp3": 93102,
	"./hitch.mp3": 21297,
	"./hog.mp3": 79209,
	"./hole.mp3": 72979,
	"./hook_1.mp3": 93408,
	"./hook_2.mp3": 183,
	"./hoop.mp3": 25395,
	"./hop.mp3": 94698,
	"./hose.mp3": 27310,
	"./hot.mp3": 34982,
	"./hut.mp3": 86384,
	"./inch.mp3": 70189,
	"./ink.mp3": 67167,
	"./it_1.mp3": 68066,
	"./it_2.mp3": 4693,
	"./itch.mp3": 45579,
	"./jet_1.mp3": 49038,
	"./jet_2.mp3": 91329,
	"./jog_1.mp3": 14607,
	"./jog_2.mp3": 98360,
	"./jug.mp3": 40265,
	"./kay.mp3": 58314,
	"./king.mp3": 70032,
	"./kite.mp3": 32352,
	"./kite_1.mp3": 76596,
	"./kite_2.mp3": 81291,
	"./laid.mp3": 9559,
	"./lake.mp3": 1800,
	"./land_1.mp3": 89970,
	"./land_2.mp3": 57541,
	"./let.mp3": 96940,
	"./lid.mp3": 9888,
	"./lied.mp3": 83051,
	"./line.mp3": 49439,
	"./lip.mp3": 9964,
	"./lock.mp3": 53828,
	"./long_1.mp3": 44579,
	"./long_2.mp3": 21388,
	"./loss.mp3": 93308,
	"./make.mp3": 58607,
	"./mat.mp3": 72321,
	"./mate_1.mp3": 39746,
	"./mate_2.mp3": 49525,
	"./may.mp3": 95336,
	"./men.mp3": 49975,
	"./moat.mp3": 79142,
	"./mole.mp3": 91596,
	"./mop_1.mp3": 41227,
	"./mop_2.mp3": 36532,
	"./more.mp3": 14650,
	"./moth_1.mp3": 33953,
	"./moth_2.mp3": 19662,
	"./nap.mp3": 27586,
	"./nest.mp3": 63575,
	"./new_1.mp3": 65489,
	"./new_2.mp3": 93054,
	"./night_1.mp3": 37465,
	"./night_2.mp3": 77574,
	"./nine.mp3": 72245,
	"./nip.mp3": 12698,
	"./nit.mp3": 68598,
	"./nose.mp3": 59692,
	"./not.mp3": 43148,
	"./note.mp3": 54037,
	"./olive_1.mp3": 54546,
	"./olive_2.mp3": 61445,
	"./out_1.mp3": 85323,
	"./out_2.mp3": 33652,
	"./ox.mp3": 76292,
	"./ox_1.mp3": 50000,
	"./ox_2.mp3": 4935,
	"./pack.mp3": 32714,
	"./pain.mp3": 46921,
	"./peel.mp3": 65451,
	"./pick.mp3": 33810,
	"./pie_1.mp3": 57213,
	"./pie_2.mp3": 96106,
	"./pin.mp3": 65086,
	"./pinch.mp3": 54263,
	"./pine.mp3": 36739,
	"./pink.mp3": 7421,
	"./pink_2.mp3": 58310,
	"./pip.mp3": 54696,
	"./pit.mp3": 82212,
	"./pitch.mp3": 76073,
	"./pop_1.mp3": 47570,
	"./pop_2.mp3": 15141,
	"./pug.mp3": 44655,
	"./quiz_1.mp3": 45826,
	"./quiz_2.mp3": 90357,
	"./rake.mp3": 3098,
	"./ran.mp3": 70536,
	"./rang.mp3": 78515,
	"./rat.mp3": 96578,
	"./rate.mp3": 48279,
	"./rest.mp3": 45371,
	"./rest_1.mp3": 57035,
	"./rest_2.mp3": 36244,
	"./right_1.mp3": 70541,
	"./right_2.mp3": 67642,
	"./ring.mp3": 79211,
	"./rip.mp3": 42262,
	"./roll.mp3": 38588,
	"./roll_2.mp3": 53583,
	"./root.mp3": 55697,
	"./rose.mp3": 67584,
	"./rot.mp3": 75992,
	"./rut.mp3": 75569,
	"./sack_1.mp3": 14071,
	"./sack_2.mp3": 75232,
	"./seal.mp3": 24742,
	"./self.mp3": 37115,
	"./shelf.mp3": 98363,
	"./shot.mp3": 64773,
	"./shout.mp3": 53940,
	"./sick.mp3": 80455,
	"./sink.mp3": 24108,
	"./six_1.mp3": 46855,
	"./six_2.mp3": 28688,
	"./spot.mp3": 74621,
	"./spring.mp3": 74910,
	"./sprint.mp3": 27713,
	"./sun.mp3": 63917,
	"./sun_1.mp3": 39081,
	"./sun_2.mp3": 39670,
	"./sung.mp3": 60812,
	"./tack.mp3": 81422,
	"./tap.mp3": 98652,
	"./tax.mp3": 32900,
	"./ten.mp3": 5406,
	"./test.mp3": 10281,
	"./test_2.mp3": 29274,
	"./text.mp3": 18804,
	"./that_1.mp3": 6686,
	"./that_2.mp3": 79121,
	"./then.mp3": 75664,
	"./thick.mp3": 35392,
	"./thin.mp3": 35060,
	"./tick.mp3": 4166,
	"./tin.mp3": 32562,
	"./tin_2.mp3": 96389,
	"./toes.mp3": 50826,
	"./tot.mp3": 69818,
	"./tote.mp3": 39359,
	"./trot.mp3": 80674,
	"./trout.mp3": 30145,
	"./tug.mp3": 25723,
	"./tug_2.mp3": 64052,
	"./up_1.mp3": 14410,
	"./up_2.mp3": 52413,
	"./vain.mp3": 11531,
	"./vet_1.mp3": 23962,
	"./vet_2.mp3": 95981,
	"./web_1.mp3": 1649,
	"./web_2.mp3": 29214,
	"./wit.mp3": 66407,
	"./with.mp3": 49917,
	"./wreck.mp3": 41037,
	"./year.mp3": 15674,
	"./yes_1.mp3": 42802,
	"./yes_2.mp3": 10373,
	"./zebra_1.mp3": 46163,
	"./zebra_2.mp3": 81180,
	"./zoo_1.mp3": 89815,
	"./zoo_2.mp3": 34624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44545;